import { formatCurrency } from "../intl";
import type { PlanEntitlements } from "../entitlements";
import type { RawPlan } from "./plan.schema";

/** `Number(null)` vira 0 — errado para um valor que precisa continuar nulo. */
function toNumberOrNull(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * Plano pronto para tela: números para a conta, strings já em reais para
 * mostrar. Veio de `fetchPlans` do web. Em plano de pacote `unitValue` chega
 * nulo e continua nulo — não vira 0.
 */
export function normalizePlan(raw: RawPlan) {
  const unitValueNumber = toNumberOrNull(raw.unitValue);
  const couponNumber = toNumberOrNull(raw.unitValueWithCoupon);
  return {
    ...raw,
    unitValueNumber,
    unitValue: unitValueNumber === null ? null : formatCurrency(unitValueNumber),
    baseValueNumber: toNumberOrNull(raw.baseValue),
    additionalUnitValueNumber: toNumberOrNull(raw.additionalUnitValue),
    unitValueWithCoupon:
      couponNumber === null ? undefined : formatCurrency(couponNumber),
    // API antiga não manda o campo; `{}` mantém a vitrine de pé.
    entitlements: (raw.entitlements ?? {}) as PlanEntitlements,
  };
}
